export default "__VITE_ASSET__CbtdkVC2__"